<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Encuestas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn
            small
            :loading="loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="refresh()"
          >
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            small
            :disabled="!selected.length || loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="view()"
          >
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            small
            :disabled="!selected.length || loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="viewSFTP()"
          >
            Información para SFTP
            <v-icon right>mdi-server-security</v-icon>
          </v-btn>
          <v-btn
            small
            :disabled="!selected.length || loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="viewLogic()"
          >
            Lógica
            <v-icon right>mdi-file-tree</v-icon>
          </v-btn>
          <v-btn
            small
            :disabled="!selected.length || loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="dialogDuplicate = true"
          >
            Duplicar
            <v-icon right>mdi-content-duplicate</v-icon>
          </v-btn>
          <v-btn
            small
            :disabled="!selected.length || loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="dialogRemove = true"
          >
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            small
            :disabled="loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="openAgrupaciones()"
          >
            Agrupaciones
            <v-icon right>mdi-group</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="mx-2"
            single-line
            hide-details
            maxlength="150"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :loading="loading"
          :search="search"
          :footer-props="{ 'items-per-page-text': 'Elementos por página' }"
          :items-per-page="5"
          item-key="id"
          single-select
          show-select
          class="elevation-1"
        >
          <v-progress-linear
            slot="progress"
            color="blue"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item.tipo_servicio="{ item }">
            {{ getName(item.tipo_servicio) }}
          </template>
          <template v-slot:item.logica="{ item }">
            <v-btn v-if="item.logica" small rounded color="success" dark
              >Disponible</v-btn
            >
            <v-btn v-else small rounded outlined color="blue-grey"
              >No disponible</v-btn
            >
          </template>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de
            {{ props.itemsLength }}
          </template>
          <template v-slot:no-data> No hay información disponible </template>
          <template v-slot:no-results> No se obtuvieron resultados </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formNew.nombre"
                      label="Nombre"
                      :rules="formRules.nombre"
                      :counter="150"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formNew.descripcion"
                      label="Descripción"
                      :rules="formRules.descripcion"
                      :counter="150"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formNew.tipo_servicio"
                      :items="tipos_servicios"
                      item-value="id"
                      item-text="nombre"
                      label="Tipo de servicio"
                      :rules="formRules.tipo_servicio"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formNew.generacion_automatica_pdfs"
                      :items="generacion_automatica_pdfs"
                      item-value="id"
                      item-text="nombre"
                      label="Generación automatica de pdfs"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formNew.fotos_con_marca_agua"
                      :items="fotos_con_marca_agua_options"
                      item-value="id"
                      item-text="nombre"
                      label="Fotos con marca de agua"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formUpdate.nombre"
                      label="Nombre"
                      :rules="formRules.nombre"
                      :counter="150"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formUpdate.descripcion"
                      label="Descripción"
                      :rules="formRules.descripcion"
                      :counter="150"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formUpdate.tipo_servicio"
                      :items="tipos_servicios"
                      item-value="id"
                      item-text="nombre"
                      label="Tipo de servicio"
                      :rules="formRules.tipo_servicio"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formUpdate.generacion_automatica_pdfs"
                      :items="generacion_automatica_pdfs"
                      item-value="id"
                      item-text="nombre"
                      label="Generación automatica de pdfs"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formUpdate.fotos_con_marca_agua"
                      :items="fotos_con_marca_agua_options"
                      item-value="id"
                      item-text="nombre"
                      label="Fotos con marca de agua"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading"
              color="primary"
              @click="cancel()"
            >
              Cancelar
            </v-btn>
            <v-btn
              text
              small
              :loading="loading"
              color="error"
              @click="remove()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDuplicate" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea duplicar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading"
              color="primary"
              @click="cancel()"
            >
              Cancelar
            </v-btn>
            <v-btn
              text
              small
              :loading="loading"
              color="error"
              @click="duplicate()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSFTP" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Detalle de registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updateSFTP()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdateSFTP" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="formSFTP.generar_archivo_sftp"
                      :items="generacion_automatica_reporte_tabular"
                      item-value="id"
                      item-text="nombre"
                      label="Generación automatica de reporte tabular"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formSFTP.nombre_de_carpeta"
                      label="Nombre de carpeta"
                      :rules="formRules.nombre_de_carpeta"
                      :counter="250"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formSFTP.tipo_archivo"
                      :items="tipo_archivos_items"
                      item-value="id"
                      item-text="nombre"
                      label="Selecciona el tipo de archivo"
                      :disabled="loading"
                      required
                    ></v-select>
                  </v-col>
                  <!--<v-col cols="12">
                    <v-text-field v-model="formSFTP.recurrencia" label="Puerto" :rules="formRules.recurrencia" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>-->
                  <v-col cols="12">
                    <v-text-field
                      v-model="formSFTP.prefijo"
                      label="Prefijo"
                      :rules="formRules.prefijo"
                      :counter="250"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogLogic"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Lógica de encuesta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title>{{
              selected.length && selected[0].nombre
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelLogic()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn
              text
              small
              :disabled="!logic.items2.length"
              :loading="loading"
              @click="saveLogic()"
            >
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="pt-5">
              <v-col sm="12" md="6">
                <v-card class="elevation-5">
                  <v-toolbar dense dark color="deep-orange" elevation="2">
                    <v-toolbar-title>Seleccionar pregunta</v-toolbar-title>
                  </v-toolbar>
                  <v-card-title>
                    <v-btn
                      small
                      :disabled="logic.selected.length != 1 || loading"
                      elevation="0"
                      color="deep-orange"
                      outlined
                      class="mx-2"
                      @click="viewQuestion()"
                    >
                      Detalle
                      <v-icon right>mdi-format-list-checkbox</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="logic.search"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    v-model="logic.selected"
                    :headers="logic.headers"
                    :items="logic.items"
                    :loading="loading"
                    :search="logic.search"
                    :footer-props="{
                      'items-per-page-text': 'Elementos por página',
                    }"
                    :items-per-page="5"
                    item-key="id"
                    single-select
                    show-select
                    class="elevation-1"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                    <template v-slot:item.tipo="{ item }">
                      {{ getType(item.tipo) }}
                    </template>
                    <template v-slot:item.opciones="{ item }">
                      {{ item.opciones.length }}
                    </template>
                    <template v-slot:footer.page-text="props">
                      Página {{ props.pageStart }} - {{ props.pageStop }} de
                      {{ props.itemsLength }}
                    </template>
                    <template v-slot:no-data>
                      No hay información disponible
                    </template>
                    <template v-slot:no-results>
                      No se obtuvieron resultados
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
              <v-col sm="12" md="6">
                <v-card class="elevation-5">
                  <v-toolbar dense dark color="blue" elevation="2">
                    <v-toolbar-title>Vista previa</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn text small :loading="loading" @click="validate()">
                      Validar
                      <v-icon right>mdi-checkbox-marked-outline</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-title>
                    <v-btn
                      small
                      :disabled="
                        logic.selected.length != 1 ||
                        (logic.items2.length && !logic.selected2.length) ||
                        logic.selected2.length > 1 ||
                        loading
                      "
                      elevation="0"
                      color="blue"
                      outlined
                      class="mx-2 mb-2"
                      @click="addLogicQuestion('down')"
                    >
                      Pregunta
                      <v-icon right>mdi-arrow-down-thick</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      :disabled="
                        logic.selected.length != 1 ||
                        logic.selected2.length == 0 ||
                        logic.selected2.length > 1 ||
                        logic.selected2[0].class === 'answer' ||
                        loading
                      "
                      elevation="0"
                      color="blue"
                      outlined
                      class="mx-2 mb-2"
                      @click="addLogicQuestion('up')"
                    >
                      Pregunta
                      <v-icon right>mdi-arrow-up-thick</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      :disabled="
                        logic.selected2.length != 2 ||
                        (logic.selected2[0].class !== 'question' &&
                          logic.selected2[0].class !== 'section' &&
                          logic.selected2[0].class !== 'signature') ||
                        (logic.selected2[1].class !== 'question' &&
                          logic.selected2[1].class !== 'section' &&
                          logic.selected2[1].class !== 'signature') ||
                        loading
                      "
                      elevation="0"
                      color="blue"
                      outlined
                      class="mx-2 mb-2"
                      @click="swapLogicElement()"
                    >
                      Intercambiar
                      <v-icon right>mdi-swap-horizontal-bold</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      :disabled="logic.selected2.length != 1 || loading"
                      elevation="0"
                      color="blue"
                      outlined
                      class="mx-2 mb-2"
                      @click="removeLogicElement()"
                    >
                      Eliminar
                      <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text
                    class="overflow-y-auto"
                    style="max-height: 500px"
                  >
                    <v-treeview
                      v-if="logic.items2.length"
                      v-model="logic.selected2"
                      :items="logic.items2"
                      item-key="id"
                      item-text="text"
                      selection-type="independent"
                      transition
                      open-all
                      selectable
                      return-object
                    >
                      <template v-slot:prepend="{ item, open }">
                        <v-icon v-if="item.class === 'question'" color="error">
                          mdi-help-circle
                        </v-icon>
                        <v-icon
                          v-else-if="item.class === 'answer'"
                          color="success"
                        >
                          mdi-alert-circle
                        </v-icon>
                        <v-icon
                          v-else-if="item.class === 'section'"
                          color="warning"
                        >
                          mdi-minus-circle
                        </v-icon>
                        <v-icon
                          v-else-if="item.class === 'signature'"
                          color="purpure"
                        >
                          mdi-signature-freehand
                        </v-icon>
                      </template>
                    </v-treeview>
                    <p v-else-if="loading" class="text-center pt-5">
                      Actualizando información...
                    </p>
                    <p v-else class="text-center pt-5">
                      No hay información disponible
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogQuestion"
        persistent
        scrollable
        max-width="600px"
      >
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Detalle de registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading"
              @click="dialogQuestion = false"
            >
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formQuestion" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formQuestion.idexterno"
                      label="Idexterno"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formQuestion.nombre"
                      label="Nombre"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="formQuestion.tipo"
                      :items="logic.tipos"
                      label="Tipo"
                      readonly
                    ></v-select>
                  </v-col>
                  <template v-for="(child, i) in formQuestion.opciones">
                    <v-col cols="12" :key="i">
                      <v-text-field
                        v-model="formQuestion.opciones[i]"
                        :label="'Opción ' + (i + 1)"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogIdexterno"
        persistent
        scrollable
        max-width="600px"
      >
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text
            >La pregunta tiene el idexterno
            <strong>{{
              logic.selected && logic.selected.length
                ? logic.selected[0].idexterno
                : ""
            }}</strong
            >, asegúrese de que la pregunta será única en la encuesta y no
            aparecerá dos veces.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :loading="loading"
              color="success"
              @click="dialogIdexterno = false"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal de Agrupaciones -->
      <v-dialog v-model="dialogAgrupaciones" persistent max-width="700px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Agrupaciones de encuesta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading"
              @click="dialogAgrupaciones = false"
            >
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="9">
                  <v-autocomplete
                    v-model="selectedGrupo"
                    :items="grupos"
                    item-value="codigo"
                    item-text="nombre"
                    label="Seleccionar grupo"
                    :disabled="loading"
                    clearable
                    return-object
                    no-data-text="No se encontraron grupos"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    small
                    elevation="0"
                    color="primary"
                    @click="dialogNuevoGrupo = true"
                    :disabled="loading"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Nuevo
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="selectedGrupo">
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-subtitle class="pb-0">
                      <strong>Encuestas en este grupo:</strong>
                    </v-card-subtitle>
                    <v-card-text>
                      <v-chip
                        v-for="(enc, idx) in selectedGrupo.encuestas"
                        :key="idx"
                        class="ma-1"
                        small
                        :color="
                          selected.length && enc.codigo === selected[0].id
                            ? 'success'
                            : 'default'
                        "
                      >
                        {{ enc.orden }}. {{ enc.nombre }}
                      </v-chip>
                      <p
                        v-if="
                          !selectedGrupo.encuestas ||
                          !selectedGrupo.encuestas.length
                        "
                        class="text-center grey--text"
                      >
                        No hay encuestas asignadas
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        text
                        color="secondary"
                        @click="abrirColumnasGrupo()"
                        :loading="loadingColumnas"
                        :disabled="
                          loading ||
                          loadingColumnas ||
                          !selectedGrupo.encuestas ||
                          !selectedGrupo.encuestas.length
                        "
                      >
                        <v-icon left small>mdi-table-column</v-icon>
                        Columnas
                      </v-btn>
                      <v-btn
                        small
                        text
                        color="primary"
                        @click="editarGrupo()"
                        :disabled="loading"
                      >
                        <v-icon left small>mdi-pencil</v-icon>
                        Editar grupo
                      </v-btn>
                      <v-btn
                        small
                        text
                        color="error"
                        @click="dialogEliminarGrupo = true"
                        :disabled="loading"
                      >
                        <v-icon left small>mdi-delete</v-icon>
                        Eliminar grupo
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Modal Nuevo Grupo -->
      <v-dialog v-model="dialogNuevoGrupo" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>{{
              formGrupo.codigo ? "Editar grupo" : "Nuevo grupo"
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelGrupo()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="guardarGrupo()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formGrupo" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formGrupo.nombre"
                      label="Nombre del grupo"
                      :rules="formRulesGrupo.nombre"
                      :counter="255"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="formGrupo.descripcion"
                      label="Descripción"
                      :disabled="loading"
                      rows="2"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-subtitle class="pb-0">
                        <strong>Encuestas del grupo:</strong>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-list dense>
                          <v-list-item
                            v-for="(enc, idx) in formGrupo.encuestas"
                            :key="enc.codigo"
                            class="mb-1"
                          >
                            <v-list-item-avatar size="24">
                              <span class="caption font-weight-bold">{{
                                idx + 1
                              }}</span>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                enc.nombre
                              }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-row no-gutters>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverEncuesta(idx, -1)"
                                  :disabled="idx === 0"
                                >
                                  <v-icon small>mdi-arrow-up</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverEncuesta(idx, 1)"
                                  :disabled="
                                    idx === formGrupo.encuestas.length - 1
                                  "
                                >
                                  <v-icon small>mdi-arrow-down</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  color="error"
                                  @click="quitarEncuestaGrupo(idx)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </v-row>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                        <p
                          v-if="!formGrupo.encuestas.length"
                          class="text-center grey--text mt-2"
                        >
                          No hay encuestas asignadas
                        </p>
                      </v-card-text>
                      <v-card-actions>
                        <v-autocomplete
                          v-model="encuestaParaAgregar"
                          :items="encuestasDisponibles"
                          item-value="id"
                          item-text="nombre"
                          label="Agregar encuesta"
                          :disabled="loading"
                          dense
                          hide-details
                          class="mr-2"
                          return-object
                          no-data-text="No se encontraron encuestas"
                        ></v-autocomplete>
                        <v-btn
                          small
                          color="primary"
                          @click="agregarEncuestaGrupo()"
                          :disabled="!encuestaParaAgregar || loading"
                        >
                          <v-icon left small>mdi-plus</v-icon>
                          Agregar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Modal Confirmar Eliminar Grupo -->
      <v-dialog v-model="dialogEliminarGrupo" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text
            >¿Realmente desea eliminar el grupo "{{
              selectedGrupo ? selectedGrupo.nombre : ""
            }}"?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading"
              color="primary"
              @click="dialogEliminarGrupo = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              text
              small
              :loading="loading"
              color="error"
              @click="eliminarGrupo()"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal Columnas del Grupo -->
      <v-dialog v-model="dialogColumnasGrupo" persistent max-width="1100px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>
              Orden de columnas: {{ grupoColumnas ? grupoColumnas.nombre : "" }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loadingColumnas"
              @click="cerrarColumnasGrupo()"
            >
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn
              text
              small
              :loading="loadingColumnas"
              @click="guardarColumnasGrupo()"
            >
              Guardar
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              text
              small
              :loading="loadingColumnas"
              @click="guardarYCerrarColumnasGrupo()"
            >
              Guardar y cerrar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <div class="d-flex align-center mb-3">
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    <input
                      ref="inputBusquedaColumna"
                      type="text"
                      placeholder="Buscar columna..."
                      class="busqueda-columna-input"
                      @input="onBusquedaColumnaInput($event.target.value)"
                    />
                    <v-btn
                      v-if="busquedaColumnaDebounced"
                      icon
                      x-small
                      @click="limpiarBusquedaColumna"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="4" class="d-flex align-center">
                  <v-btn
                    small
                    color="secondary"
                    :disabled="
                      columnasSeleccionadas.length < 2 || loadingColumnas
                    "
                    @click="agruparColumnasSeleccionadas()"
                  >
                    <v-icon left small>mdi-link-variant</v-icon>
                    Agrupar seleccionadas ({{ columnasSeleccionadas.length }})
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <!-- Columnas disponibles -->
                <v-col cols="7">
                  <v-card outlined>
                    <v-card-subtitle
                      class="pb-0 d-flex justify-space-between align-center"
                    >
                      <strong
                        >Elementos ({{ columnasGrupoFiltradas.length }})</strong
                      >
                      <div>
                        <v-btn
                          x-small
                          text
                          color="primary"
                          @click="seleccionarTodas()"
                          class="mr-1"
                        >
                          <v-icon left x-small
                            >mdi-checkbox-multiple-marked</v-icon
                          >
                          Sel. filtradas
                        </v-btn>
                        <v-btn
                          x-small
                          text
                          color="primary"
                          @click="resetearOrdenColumnas"
                        >
                          <v-icon left x-small>mdi-refresh</v-icon>
                          Resetear
                        </v-btn>
                      </div>
                    </v-card-subtitle>
                    <v-card-text style="max-height: 450px; overflow-y: auto">
                      <v-list dense>
                        <template v-for="(item, idx) in columnasGrupoFiltradas">
                          <!-- Elemento de Agrupación -->
                          <v-list-item
                            v-if="item.esAgrupacion"
                            :key="'agrup-' + item.agrupacionId"
                            class="mb-1 elevation-2 rounded orange lighten-3"
                          >
                            <v-list-item-avatar size="32" class="mr-2">
                              <v-chip small color="orange darken-2" dark>{{
                                idx + 1
                              }}</v-chip>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                <v-icon small class="mr-1"
                                  >mdi-link-variant</v-icon
                                >
                                {{ item.nombreUnificado }}
                                <v-chip
                                  x-small
                                  color="orange darken-1"
                                  dark
                                  class="ml-1"
                                >
                                  {{ item.columnas.length }} columnas
                                </v-chip>
                              </v-list-item-title>
                              <v-list-item-subtitle class="caption">
                                <v-chip
                                  v-for="col in item.columnas.slice(0, 3)"
                                  :key="
                                    col.idexterno + '-' + col.encuestaCodigo
                                  "
                                  x-small
                                  outlined
                                  class="mr-1"
                                >
                                  {{ col.idexterno }}
                                </v-chip>
                                <span
                                  v-if="item.columnas.length > 3"
                                  class="grey--text"
                                >
                                  +{{ item.columnas.length - 3 }} más
                                </span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-row no-gutters>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverAgrupacion(item, -1)"
                                  :disabled="idx === 0 || loadingColumnas"
                                  title="Mover arriba"
                                >
                                  <v-icon small>mdi-arrow-up</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverAgrupacion(item, 1)"
                                  :disabled="
                                    idx === columnasGrupoFiltradas.length - 1 ||
                                    loadingColumnas
                                  "
                                  title="Mover abajo"
                                >
                                  <v-icon small>mdi-arrow-down</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverAgrupacionAlInicio(item)"
                                  :disabled="idx === 0 || loadingColumnas"
                                  title="Mover al inicio"
                                >
                                  <v-icon small>mdi-arrow-collapse-up</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverAgrupacionAlFinal(item)"
                                  :disabled="
                                    idx === columnasGrupoFiltradas.length - 1 ||
                                    loadingColumnas
                                  "
                                  title="Mover al final"
                                >
                                  <v-icon small>mdi-arrow-collapse-down</v-icon>
                                </v-btn>
                              </v-row>
                            </v-list-item-action>
                          </v-list-item>
                          <!-- Columna Individual -->
                          <v-list-item
                            v-else
                            :key="
                              item.idexterno +
                              '-' +
                              item.encuestaCodigo +
                              '-' +
                              idx
                            "
                            class="mb-1 elevation-1 rounded"
                            :class="{
                              'grey lighten-4': idx % 2 === 0,
                              'light-blue lighten-4':
                                isColumnaSeleccionada(item),
                            }"
                          >
                            <v-list-item-action class="mr-2">
                              <v-checkbox
                                v-model="columnasSeleccionadas"
                                :value="getClaveColumna(item)"
                                hide-details
                                dense
                              ></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-avatar size="32" class="mr-2">
                              <v-chip small color="primary" dark>{{
                                idx + 1
                              }}</v-chip>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">
                                {{ item.nombre }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="caption">
                                <v-chip x-small outlined class="mr-1">{{
                                  item.idexterno
                                }}</v-chip>
                                <span
                                  v-if="
                                    item.encuestasAgrupadas &&
                                    item.encuestasAgrupadas.length > 1
                                  "
                                  class="blue--text text--darken-2"
                                  :title="
                                    item.encuestasAgrupadas
                                      .map((e) => e.nombre)
                                      .join(' | ')
                                  "
                                  style="cursor: help"
                                >
                                  <v-icon
                                    x-small
                                    color="blue darken-2"
                                    class="mr-1"
                                    >mdi-link-variant</v-icon
                                  >
                                  {{
                                    getEncuestasAgrupadasTexto(
                                      item.encuestasAgrupadas
                                    )
                                  }}
                                </span>
                                <span v-else class="grey--text">{{
                                  item.encuestaNombre
                                }}</span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-row no-gutters>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverColumnaEnLista(item, -1)"
                                  :disabled="idx === 0 || loadingColumnas"
                                  title="Mover arriba"
                                >
                                  <v-icon small>mdi-arrow-up</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverColumnaEnLista(item, 1)"
                                  :disabled="
                                    idx === columnasGrupoFiltradas.length - 1 ||
                                    loadingColumnas
                                  "
                                  title="Mover abajo"
                                >
                                  <v-icon small>mdi-arrow-down</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverColumnaAlInicioEnLista(item)"
                                  :disabled="idx === 0 || loadingColumnas"
                                  title="Mover al inicio"
                                >
                                  <v-icon small>mdi-arrow-collapse-up</v-icon>
                                </v-btn>
                                <v-btn
                                  icon
                                  x-small
                                  @click="moverColumnaAlFinalEnLista(item)"
                                  :disabled="
                                    idx === columnasGrupoFiltradas.length - 1 ||
                                    loadingColumnas
                                  "
                                  title="Mover al final"
                                >
                                  <v-icon small>mdi-arrow-collapse-down</v-icon>
                                </v-btn>
                              </v-row>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                      <p
                        v-if="columnasGrupo.length === 0"
                        class="text-center grey--text mt-4"
                      >
                        No hay columnas disponibles. Asegúrese de que el grupo
                        tenga encuestas asignadas.
                      </p>
                      <p
                        v-if="
                          columnasGrupo.length > 0 &&
                          columnasGrupoFiltradas.length === 0
                        "
                        class="text-center grey--text mt-4"
                      >
                        No se encontraron columnas con el filtro aplicado.
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <!-- Panel de agrupaciones -->
                <v-col cols="5">
                  <v-card outlined>
                    <v-card-subtitle class="pb-0">
                      <strong
                        >Agrupaciones ({{
                          agrupacionesColumnas.length
                        }})</strong
                      >
                    </v-card-subtitle>
                    <v-card-text style="max-height: 450px; overflow-y: auto">
                      <div
                        v-if="agrupacionesColumnas.length === 0"
                        class="text-center grey--text mt-4"
                      >
                        <v-icon large color="grey lighten-1"
                          >mdi-link-variant-off</v-icon
                        >
                        <p class="mt-2">No hay agrupaciones creadas</p>
                        <p class="caption">
                          Seleccione columnas similares y haga clic en "Agrupar
                          seleccionadas"
                        </p>
                      </div>
                      <v-card
                        v-for="(agrup, idx) in agrupacionesColumnas"
                        :key="agrup.id"
                        outlined
                        class="mb-2"
                      >
                        <v-card-subtitle class="py-1 d-flex align-center">
                          <v-icon small class="mr-1">mdi-link-variant</v-icon>
                          <v-text-field
                            v-model="agrup.nombreUnificado"
                            dense
                            hide-details
                            single-line
                            class="caption"
                            placeholder="Nombre unificado..."
                          ></v-text-field>
                          <v-btn
                            icon
                            x-small
                            color="error"
                            @click="eliminarAgrupacion(idx)"
                            title="Eliminar agrupación"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-card-subtitle>
                        <v-card-text class="py-1">
                          <v-chip
                            v-for="(col, colIdx) in agrup.columnas"
                            :key="col.idexterno + '-' + col.encuestaCodigo"
                            x-small
                            close
                            class="ma-1"
                            @click:close="quitarDeAgrupacion(idx, colIdx)"
                          >
                            {{ col.idexterno }} ({{
                              col.encuestaNombre.substring(0, 15)
                            }}...)
                          </v-chip>
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar
        v-model="success"
        color="success"
        :timeout="2500"
        bottom
        right
      >
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from "@/utils/services";
import moment from "moment";
import Vue from "vue";

export default {
  name: "encuestas",
  data: () => ({
    loading: false,
    error: false,
    msgError: "",
    success: false,
    msgSuccess: "",
    search: "",
    headers: [
      { text: "Nombre", align: "center", sortable: false, value: "nombre" },
      {
        text: "Descripción",
        align: "center",
        sortable: false,
        value: "descripcion",
      },
      {
        text: "Tipo de servicio",
        align: "center",
        sortable: false,
        value: "tipo_servicio",
      },
      {
        text: "Lógica de preguntas",
        align: "center",
        sortable: false,
        value: "logica",
      },
      {
        text: "Fecha actualización",
        align: "center",
        sortable: false,
        value: "fecha_cambio",
      },
    ],
    items: [],
    tipos_servicios: [],
    generacion_automatica_reporte_tabular: [
      { nombre: "Si", id: true },
      { nombre: "No", id: false },
    ],
    generacion_automatica_pdfs: [
      { nombre: "Si", id: true },
      { nombre: "No", id: false },
    ],
    fotos_con_marca_agua_options: [
      { nombre: "Si", id: true },
      { nombre: "No", id: false },
    ],
    tipo_archivos_items: [
      { nombre: "csv", id: "csv" },
      { nombre: "txt", id: "txt" },
    ],
    selected: [],
    logic: {
      search: "",
      headers: [
        {
          text: "Idexterno",
          align: "center",
          sortable: false,
          value: "idexterno",
        },
        { text: "Nombre", align: "center", sortable: false, value: "nombre" },
        { text: "Tipo", align: "center", sortable: false, value: "tipo" },
        {
          text: "No. opciones",
          align: "center",
          sortable: false,
          value: "opciones",
        },
      ],
      items: [],
      tipos: [
        { text: "Selección múltiple", value: "seleccion_multiple" },
        { text: "Opción múltiple", value: "opcion_multiple" },
        { text: "Texto corto", value: "texto_corto" },
        { text: "Texto largo", value: "texto_largo" },
        { text: "Número", value: "numero" },
        { text: "Fecha", value: "fecha" },
        { text: "Foto", value: "foto" },
        { text: "Coordenadas", value: "coordenadas" },
        { text: "Comentarios", value: "comentarios" },
        { text: "Sección", value: "seccion" },
        { text: "Firma", value: "firma" },
      ],
      selected: [],
      items2: [],
      selected2: [],
    },
    dialogNew: false,
    dialogUpdate: false,
    dialogRemove: false,
    dialogDuplicate: false,
    dialogLogic: false,
    dialogQuestion: false,
    dialogIdexterno: false,
    dialogSFTP: false,
    formNew: {
      nombre: "",
      descripcion: "",
      tipo_servicio: "",
      logica: "",
      generacion_automatica_pdfs: false,
      generacion_automatica_reporte_tabular: false,
      fotos_con_marca_agua: false,
    },
    formUpdate: {
      id: "",
      nombre: "",
      descripcion: "",
      tipo_servicio: "",
      logica: "",
      generacion_automatica_pdfs: false,
      generacion_automatica_reporte_tabular: false,
      fotos_con_marca_agua: false,
    },
    formSFTP: {
      generar_archivo_sftp: false,
      nombre_de_carpeta: null,
      tipo_archivo: null,
      recurrencia: null,
      prefijo: null,
    },
    formQuestion: {
      id: "",
      idexterno: "",
      nombre: "",
      tipo: "",
      opciones: [],
    },
    formRules: {
      nombre: [
        (v) => !!v || "El nombre es obligatorio",
        (v) => (v && v.length <= 150) || "El nombre excede la longitud máxima",
      ],
      descripcion: [
        (v) => !!v || "La descripción es obligatoria",
        (v) =>
          (v && v.length <= 150) || "La descripción excede la longitud máxima",
      ],
      tipo_servicio: [(v) => !!v || "El tipo de servicio es obligatorio"],
      generar_archivo_sftp: [
        (v) => !!v || "Es obligatorio",
        (v) =>
          (v && v.length <= 250) ||
          "La dirección fiscal excede la longitud máxima",
      ],
      nombre_de_carpeta: [
        (v) => !!v || "Es obligatorio",
        (v) =>
          (v && v.length <= 250) ||
          "La dirección fiscal excede la longitud máxima",
      ],
      tipo_archivo: [
        (v) => !!v || "Es obligatorio",
        (v) =>
          (v && v.length <= 250) ||
          "La dirección fiscal excede la longitud máxima",
      ],
      recurrencia: [
        (v) => !!v || "Es obligatorio",
        (v) =>
          (v && v.length <= 250) ||
          "La dirección fiscal excede la longitud máxima",
      ],
      prefijo: [
        (v) => !!v || "Es obligatorio",
        (v) =>
          (v && v.length <= 250) ||
          "La dirección fiscal excede la longitud máxima",
      ],
    },
    // Variables para Agrupaciones
    dialogAgrupaciones: false,
    dialogNuevoGrupo: false,
    dialogEliminarGrupo: false,
    dialogColumnasGrupo: false,
    grupos: [],
    selectedGrupo: null,
    encuestaParaAgregar: null,
    formGrupo: {
      codigo: null,
      nombre: "",
      descripcion: "",
      encuestas: [],
    },
    formRulesGrupo: {
      nombre: [
        (v) => !!v || "El nombre es obligatorio",
        (v) => (v && v.length <= 255) || "El nombre excede la longitud máxima",
      ],
    },
    // Variables para Columnas del Grupo
    columnasGrupo: [],
    columnasGrupoOriginal: [],
    grupoColumnas: null,
    loadingColumnas: false,
    busquedaColumnaDebounced: "",
    debounceTimer: null,
    // Variables para agrupaciones de columnas
    agrupacionesColumnas: [],
    columnasSeleccionadas: [],
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.loading = true;
      services
        .ws("get", "encuestas")
        .then((res) => {
          if (res.ok) {
            this.items = res.data.encuestas;
            this.tipos_servicios = res.data.tipos_servicios;
            this.selected = [];
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset();
      } else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset();
      } else if (this.$refs.formUpdateSFTP) {
        this.$refs.formUpdateSFTP.reset();
      }
      for (let key in this.formNew) {
        if (!Array.isArray(this.formNew[key])) {
          this.formNew[key] = "";
        } else {
          this.formNew[key] = [];
        }
      }
      for (let key in this.formUpdate) {
        if (!Array.isArray(this.formUpdate[key])) {
          this.formUpdate[key] = "";
        } else {
          this.formUpdate[key] = [];
        }
      }
    },
    cancel() {
      this.clear();
      this.selected = [];
      this.preguntas = [];
      this.dialogNew = false;
      this.dialogUpdate = false;
      this.dialogRemove = false;
      this.dialogDuplicate = false;
      this.dialogLogic = false;
      this.dialogSFTP = false;
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true;
        setTimeout(() => {
          services
            .ws("post", "nuevaEncuesta", this.formNew)
            .then((res) => {
              if (res.ok) {
                this.cancel();
                this.refresh();
                this.success = true;
                this.msgSuccess = res.message;
              } else {
                this.error = true;
                this.msgError = res.message;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }, 800);
      } else {
        this.error = true;
        this.msgError = "Algunos datos son inválidos";
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]));
      this.dialogUpdate = true;
    },
    viewSFTP() {
      this.loading = true;
      let jwt = Vue.prototype.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      /*consultarEncuestasSFTP
        actualizarEncuestasSFTP*/
      this.axios({
        url:
          services.routes.consultarEncuestasSFTP + "?id=" + this.selected[0].id,
        method: "GET",
        headers: headers,
      })
        .then((response) => {
          this.formSFTP.generar_archivo_sftp = response.data
            .generar_archivo_sftp
            ? true
            : false;
          this.formSFTP.nombre_de_carpeta = response.data.nombre_de_carpeta;
          this.formSFTP.tipo_archivo = response.data.tipo_archivo;
          this.formSFTP.recurrencia = response.data.recurrencia;
          this.formSFTP.prefijo = response.data.prefijo;
          this.dialogSFTP = true;
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.msgError = "El detalle de la empresa no fue obtenido";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateSFTP() {
      this.loading = true;
      let jwt = Vue.prototype.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      let data = {
        id: this.selected[0].id,
        generar_archivo_sftp: this.formSFTP.generar_archivo_sftp,
        nombre_de_carpeta: this.formSFTP.nombre_de_carpeta,
        tipo_archivo: this.formSFTP.tipo_archivo,
        recurrencia: this.formSFTP.recurrencia,
        prefijo: this.formSFTP.prefijo,
      };
      console.log(data);
      this.axios({
        url: services.routes.actualizarEncuestasSFTP,
        method: "POST",
        headers: headers,
        data: data,
      })
        .then(() => {
          this.cancel();
          this.success = true;
          this.msgSuccess = "La información sftp de la empresa fue actualizado";
        })
        .catch(() => {
          this.error = true;
          this.msgError =
            "La información sftp de la empresa no fue actualizado";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true;
        setTimeout(() => {
          services
            .ws("post", "actualizarEncuesta", this.formUpdate)
            .then((res) => {
              if (res.ok) {
                this.cancel();
                this.refresh();
                this.success = true;
                this.msgSuccess = res.message;
              } else {
                this.error = true;
                this.msgError = res.message;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }, 800);
      } else {
        this.error = true;
        this.msgError = "Algunos datos son inválidos";
      }
    },
    remove() {
      this.loading = true;
      setTimeout(() => {
        let id = this.selected[0].id;
        services
          .ws("post", "eliminarEncuesta", { id })
          .then((res) => {
            if (res.ok) {
              this.cancel();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 800);
    },
    getName(id) {
      for (let i = 0; i < this.tipos_servicios.length; i++) {
        if (this.tipos_servicios[i].id == id) {
          return this.tipos_servicios[i].nombre;
        }
      }
      return null;
    },
    viewLogic() {
      this.loading = true;
      services
        .ws("get", "preguntas")
        .then((res) => {
          if (res.ok) {
            this.logic.items = res.data.preguntas;
            try {
              this.logic.items2 = this.selected[0].logica
                ? JSON.parse(
                    decodeURIComponent(escape(atob(this.selected[0].logica)))
                  )
                : [];
            } catch (e) {
              this.logic.items2 = this.selected[0].logica
                ? JSON.parse(atob(this.selected[0].logica))
                : [];
            }
            this.dialogLogic = true;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearLogic() {
      if (this.$refs.formQuestion) {
        this.$refs.formQuestion.reset();
      }
      for (let key in this.formQuestion) {
        if (!Array.isArray(this.formQuestion[key])) {
          this.formQuestion[key] = "";
        } else {
          this.formQuestion[key] = [];
        }
      }
    },
    cancelLogic() {
      this.clearLogic();
      this.logic.search = "";
      this.logic.items = [];
      this.logic.selected = [];
      this.logic.items2 = [];
      this.logic.selected2 = [];
      this.dialogLogic = false;
      this.dialogSFTP = false;
    },
    saveLogic() {
      if (!this.logic.items2.length) {
        this.error = true;
        this.msgError = "No existen elementos en la vista previa";
      } else {
        this.loading = true;
        setTimeout(() => {
          let data = {
            id: this.selected[0].id,
            logica: btoa(
              unescape(encodeURIComponent(JSON.stringify(this.logic.items2)))
            ),
          };
          services
            .ws("post", "actualizarLogicaEncuesta", data)
            .then((res) => {
              if (res.ok) {
                this.cancelLogic();
                this.refresh();
                this.success = true;
                this.msgSuccess = res.message;
              } else {
                this.error = true;
                this.msgError = res.message;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }, 800);
      }
    },
    duplicate() {
      this.loading = true;
      setTimeout(() => {
        let id = this.selected[0].id;
        services
          .ws("post", "duplicarEncuesta", { id })
          .then((res) => {
            if (res.ok) {
              this.cancel();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 800);
    },
    viewQuestion() {
      this.formQuestion = JSON.parse(JSON.stringify(this.logic.selected[0]));
      this.dialogQuestion = true;
    },
    getType(val) {
      for (let i = 0; i < this.logic.tipos.length; i++) {
        if (this.logic.tipos[i].value == val) {
          return this.logic.tipos[i].text;
        }
      }
      return null;
    },
    validate() {
      this.loading = true;
      setTimeout(() => {
        this.success = true;
        this.msgSuccess = "La lógica de la encuesta es correcta";
        this.loading = false;
      }, 800);
    },
    getArrayIdexterno(items, arr) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].children) {
          this.getArrayIdexterno(items[i].children, arr);
        } else {
          if (items[i].detail && items[i].detail.idexterno) {
            arr.push(items[i].detail.idexterno);
          }
        }
      }
    },
    addLogicQuestion(dir) {
      // Se muestra alerta cuando se quiere utilizar una pregunta con el mismo idexterno
      let detail = JSON.parse(JSON.stringify(this.logic.selected[0]));
      let auxArr = [];
      this.getArrayIdexterno(this.logic.items2, auxArr);
      if (detail && detail.idexterno) {
        if (auxArr.indexOf(detail.idexterno) >= 0) {
          this.dialogIdexterno = true;
        }
      }

      let classType = "question";
      switch (this.logic.selected[0].tipo) {
        case "seccion":
          classType = "section";
          break;
        case "firma":
          classType = "signature";
          break;
        default:
          classType = "question";
      }

      if (dir === "down" && this.logic.selected.length != 1) {
        this.error = true;
        this.msgError = "Debe seleccionar una sola pregunta";
      } else if (dir === "down" && this.logic.selected2.length > 1) {
        this.error = true;
        this.msgError = "Debe seleccionar un solo elemento de la vista previa";
      } else if (dir === "up" && this.logic.selected.length != 1) {
        this.error = true;
        this.msgError = "Debe seleccionar un sola pregunta";
      } else if (dir === "up" && this.logic.selected2.length != 1) {
        this.error = true;
        this.msgError = "Debe seleccionar un solo elemento de la vista previa";
      } else if (
        dir === "up" &&
        this.logic.selected2.length != 1 &&
        this.logic.selected2[0].class === "answer"
      ) {
        this.error = true;
        this.msgError =
          "No se puede agregar una pregunta en la parte superior del elemento seleccionado";
      } else if (
        this.logic.selected[0].tipo !== "opcion_multiple" &&
        dir === "down" &&
        this.logic.selected2.length == 0
      ) {
        let det = JSON.parse(JSON.stringify(this.logic.selected[0]));
        let ele = {
          id: moment().format("x"),
          text: det.idexterno + " - " + det.nombre,
          class: classType,
          detail: det,
        };
        this.logic.items2.push(ele);
      } else if (
        this.logic.selected[0].tipo !== "opcion_multiple" &&
        dir === "down" &&
        this.logic.selected2.length == 1
      ) {
        let id = this.logic.selected2[0].id;
        let data = this.getNode(this.logic.items2, id);
        if (data !== null) {
          let det = JSON.parse(JSON.stringify(this.logic.selected[0]));
          let ele = {
            id: moment().format("x"),
            text: det.idexterno + " - " + det.nombre,
            class: classType,
            detail: det,
          };
          if (data.class === "answer") {
            data.tree[data.idx].children.push(ele);
          } else {
            data.tree.splice(data.idx + 1, 0, ele);
          }
        }
      } else if (
        this.logic.selected[0].tipo !== "opcion_multiple" &&
        dir === "up" &&
        this.logic.selected2.length == 1
      ) {
        let id = this.logic.selected2[0].id;
        let data = this.getNode(this.logic.items2, id);
        if (data !== null) {
          let det = JSON.parse(JSON.stringify(this.logic.selected[0]));
          let ele = {
            id: moment().format("x"),
            text: det.idexterno + " - " + det.nombre,
            class: classType,
            detail: det,
          };
          data.tree.splice(data.idx, 0, ele);
        }
      } else if (
        this.logic.selected[0].tipo === "opcion_multiple" &&
        dir === "down" &&
        this.logic.selected2.length == 0
      ) {
        let det = JSON.parse(JSON.stringify(this.logic.selected[0]));
        let ele = {
          id: moment().format("x"),
          text: det.idexterno + " - " + det.nombre,
          class: classType,
          detail: det,
          children: [],
        };
        let nodes = [];
        for (let i = 0; i < this.logic.selected[0].opciones.length; i++) {
          nodes.push({
            id: (parseInt(moment().format("x")) + (i + 1)).toString(),
            text: this.logic.selected[0].opciones[i],
            class: "answer",
            detail: null,
            children: [],
          });
        }
        ele.children = nodes;
        this.logic.items2.push(ele);
      } else if (
        this.logic.selected[0].tipo === "opcion_multiple" &&
        dir === "down" &&
        this.logic.selected2.length == 1
      ) {
        let id = this.logic.selected2[0].id;
        let data = this.getNode(this.logic.items2, id);
        if (data !== null) {
          let det = JSON.parse(JSON.stringify(this.logic.selected[0]));
          let ele = {
            id: moment().format("x"),
            text: det.idexterno + " - " + det.nombre,
            class: classType,
            detail: det,
            children: [],
          };
          let nodes = [];
          for (let i = 0; i < this.logic.selected[0].opciones.length; i++) {
            nodes.push({
              id: (parseInt(moment().format("x")) + (i + 1)).toString(),
              text: this.logic.selected[0].opciones[i],
              class: "answer",
              detail: null,
              children: [],
            });
          }
          ele.children = nodes;
          if (data.class === "answer") {
            data.tree[data.idx].children.push(ele);
          } else {
            data.tree.splice(data.idx + 1, 0, ele);
          }
        }
      } else if (
        this.logic.selected[0].tipo === "opcion_multiple" &&
        dir === "up" &&
        this.logic.selected2.length == 1
      ) {
        let id = this.logic.selected2[0].id;
        let data = this.getNode(this.logic.items2, id);
        if (data !== null && data.class !== "answer") {
          let det = JSON.parse(JSON.stringify(this.logic.selected[0]));
          let ele = {
            id: moment().format("x"),
            text: det.idexterno + " - " + det.nombre,
            class: classType,
            detail: det,
            children: null,
          };
          let nodes = [];
          for (let i = 0; i < this.logic.selected[0].opciones.length; i++) {
            nodes.push({
              id: (parseInt(moment().format("x")) + (i + 1)).toString(),
              text: this.logic.selected[0].opciones[i],
              class: "answer",
              detail: null,
            });
          }
          ele.children = nodes;
          data.tree.splice(data.idx, 0, ele);
        } else {
          this.error = true;
          this.msgError = "Acción no disponible";
        }
      }
      this.loading = true;
      let items = this.logic.items2;
      this.logic.items2 = [];
      setTimeout(() => {
        this.logic.items2 = items;
        this.loading = false;
      }, 100);
    },
    swapLogicElement() {
      if (
        this.logic.selected2.length != 2 ||
        (this.logic.selected2[0].class !== "question" &&
          this.logic.selected2[0].class !== "section" &&
          this.logic.selected2[0].class !== "signature") ||
        (this.logic.selected2[1].class !== "question" &&
          this.logic.selected2[1].class !== "section" &&
          this.logic.selected2[1].class !== "signature")
      ) {
        this.error = true;
        this.msgError = "Debe seleccionar sólo dos preguntas";
      } else {
        let id = this.logic.selected2[0].id;
        let data = this.getNode(this.logic.items2, id);
        let tree = data ? JSON.stringify(data.tree) : "";
        let id2 = this.logic.selected2[1].id;
        let data2 = this.getNode(this.logic.items2, id2);
        let tree2 = data2 ? JSON.stringify(data2.tree) : "";
        if (tree === "" || tree2 === "" || tree !== tree2) {
          this.error = true;
          this.msgError =
            "Las preguntas seleccionadas deben pertenecer al mismo nivel";
        } else {
          let tmp = data.tree[data.idx];
          data.tree[data.idx] = data2.tree[data2.idx];
          data2.tree[data2.idx] = tmp;
          this.loading = true;
          let items = this.logic.items2;
          this.logic.items2 = [];
          setTimeout(() => {
            this.logic.items2 = items;
            this.loading = false;
          }, 100);
        }
      }
    },
    removeLogicElement() {
      if (this.logic.selected2.length != 1) {
        this.error = true;
        this.msgError = "Debe seleccionar un solo elemento de la vista previa";
      } else {
        let id = this.logic.selected2[0].id;
        let data = this.getNode(this.logic.items2, id);
        if (data !== null) {
          this.logic.selected2 = [];
          data.tree.splice(data.idx, 1);
        }
      }
    },
    getNode(tree, id) {
      let info = null;
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].id == id) {
          info = JSON.parse(JSON.stringify(tree[i]));
          info.tree = tree;
          info.idx = i;
        } else if (tree[i].children && tree[i].children.length) {
          let node = this.getNode(tree[i].children, id);
          info = node ? node : info;
        }
      }
      return info;
    },
    // Métodos para Agrupaciones
    openAgrupaciones() {
      this.loading = true;
      services
        .ws("get", "grupos")
        .then((res) => {
          if (res.ok) {
            this.grupos = res.data.grupos;
            this.selectedGrupo = null;
            this.dialogAgrupaciones = true;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelGrupo() {
      if (this.$refs.formGrupo) {
        this.$refs.formGrupo.reset();
      }
      this.formGrupo = {
        codigo: null,
        nombre: "",
        descripcion: "",
        encuestas: [],
      };
      this.encuestaParaAgregar = null;
      this.dialogNuevoGrupo = false;
    },
    guardarGrupo() {
      if (this.$refs.formGrupo.validate()) {
        this.loading = true;
        const esEdicion = !!this.formGrupo.codigo;
        const codigoGrupoEditado = this.formGrupo.codigo;
        let data = {
          nombre: this.formGrupo.nombre,
          descripcion: this.formGrupo.descripcion,
          encuestas: this.formGrupo.encuestas.map((enc, idx) => ({
            codigo: enc.codigo,
            orden: idx + 1,
          })),
        };
        let endpoint = "nuevoGrupo";
        if (esEdicion) {
          data.codigo = codigoGrupoEditado;
          endpoint = "actualizarGrupo";
        }
        services
          .ws("post", endpoint, data)
          .then((res) => {
            if (res.ok) {
              this.cancelGrupo();
              // Recargar grupos y mantener selección si es edición
              services.ws("get", "grupos").then((resGrupos) => {
                if (resGrupos.ok) {
                  this.grupos = resGrupos.data.grupos;
                  // Si era edición, re-seleccionar el grupo editado
                  if (esEdicion && codigoGrupoEditado) {
                    this.selectedGrupo =
                      this.grupos.find(
                        (g) => g.codigo === codigoGrupoEditado
                      ) || null;
                  }
                }
              });
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "Algunos datos son inválidos";
      }
    },
    editarGrupo() {
      if (this.selectedGrupo) {
        this.formGrupo = {
          codigo: this.selectedGrupo.codigo,
          nombre: this.selectedGrupo.nombre,
          descripcion: this.selectedGrupo.descripcion || "",
          encuestas: this.selectedGrupo.encuestas.map((enc) => ({
            codigo: enc.codigo,
            nombre: enc.nombre,
            orden: enc.orden,
          })),
        };
        this.dialogNuevoGrupo = true;
      }
    },
    eliminarGrupo() {
      if (this.selectedGrupo) {
        this.loading = true;
        services
          .ws("post", "eliminarGrupo", { codigo: this.selectedGrupo.codigo })
          .then((res) => {
            if (res.ok) {
              this.dialogEliminarGrupo = false;
              this.selectedGrupo = null;
              this.openAgrupaciones();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    agregarEncuestaGrupo() {
      if (this.encuestaParaAgregar) {
        let yaExiste = this.formGrupo.encuestas.find(
          (e) => e.codigo === this.encuestaParaAgregar.id
        );
        if (yaExiste) {
          this.error = true;
          this.msgError = "La encuesta ya está en el grupo";
          return;
        }
        // Validar que la encuesta no esté en otro grupo
        const encuestaEnOtroGrupo = this.grupos.find(
          (g) =>
            g.codigo !== this.formGrupo.codigo &&
            g.encuestas &&
            g.encuestas.some((e) => e.codigo === this.encuestaParaAgregar.id)
        );
        if (encuestaEnOtroGrupo) {
          this.error = true;
          this.msgError = `La encuesta "${this.encuestaParaAgregar.nombre}" ya pertenece al grupo "${encuestaEnOtroGrupo.nombre}"`;
          return;
        }
        this.formGrupo.encuestas.push({
          codigo: this.encuestaParaAgregar.id,
          nombre: this.encuestaParaAgregar.nombre,
          orden: this.formGrupo.encuestas.length + 1,
        });
        this.encuestaParaAgregar = null;
      }
    },
    quitarEncuestaGrupo(idx) {
      this.formGrupo.encuestas.splice(idx, 1);
    },
    moverEncuesta(idx, direction) {
      let newIdx = idx + direction;
      if (newIdx >= 0 && newIdx < this.formGrupo.encuestas.length) {
        let temp = this.formGrupo.encuestas[idx];
        this.$set(
          this.formGrupo.encuestas,
          idx,
          this.formGrupo.encuestas[newIdx]
        );
        this.$set(this.formGrupo.encuestas, newIdx, temp);
      }
    },
    // Métodos para Columnas del Grupo
    onBusquedaColumnaInput(value) {
      // Debounce de 300ms para mejor rendimiento
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.busquedaColumnaDebounced = value || "";
      }, 300);
    },
    limpiarBusquedaColumna() {
      this.busquedaColumnaDebounced = "";
      if (this.$refs.inputBusquedaColumna) {
        this.$refs.inputBusquedaColumna.value = "";
      }
    },
    abrirColumnasGrupo() {
      if (!this.selectedGrupo) return;
      this.loadingColumnas = true;
      this.busquedaColumnaDebounced = "";
      this.columnasSeleccionadas = [];
      services
        .ws("get", "obtenerColumnasGrupo", {
          codigo: this.selectedGrupo.codigo,
        })
        .then((res) => {
          console.log("Respuesta obtenerColumnasGrupo:", res);
          if (res.ok) {
            this.grupoColumnas = res.data.grupo;
            this.columnasGrupo = res.data.columnas || [];
            this.agrupacionesColumnas = res.data.agrupaciones || [];
            // Marcar las columnas que pertenecen a agrupaciones
            this.agrupacionesColumnas.forEach((agrup) => {
              agrup.columnas.forEach((colAgrup) => {
                const col = this.columnasGrupo.find(
                  (c) =>
                    c.idexterno === colAgrup.idexterno &&
                    c.encuestaCodigo === colAgrup.encuestaCodigo
                );
                if (col) {
                  col.agrupacionId = agrup.id;
                }
              });
            });
            this.columnasGrupoOriginal = JSON.parse(
              JSON.stringify(this.columnasGrupo)
            );
            this.dialogColumnasGrupo = true;
          } else {
            this.error = true;
            this.msgError = res.message || "Error al obtener columnas";
          }
        })
        .catch((err) => {
          console.error("Error en obtenerColumnasGrupo:", err);
          this.error = true;
          this.msgError = "Error inesperado al obtener columnas";
        })
        .finally(() => {
          this.loadingColumnas = false;
        });
    },
    getOrdenReal(col) {
      return this.columnasGrupo.findIndex((c) => c.idexterno === col.idexterno);
    },
    moverColumna(col, direction) {
      const idx = this.getOrdenReal(col);
      const newIdx = idx + direction;
      if (newIdx >= 0 && newIdx < this.columnasGrupo.length) {
        const temp = this.columnasGrupo[idx];
        this.$set(this.columnasGrupo, idx, this.columnasGrupo[newIdx]);
        this.$set(this.columnasGrupo, newIdx, temp);
      }
    },
    moverColumnaAlInicio(col) {
      const idx = this.getOrdenReal(col);
      if (idx > 0) {
        const item = this.columnasGrupo.splice(idx, 1)[0];
        this.columnasGrupo.unshift(item);
      }
    },
    moverColumnaAlFinal(col) {
      const idx = this.getOrdenReal(col);
      if (idx < this.columnasGrupo.length - 1) {
        const item = this.columnasGrupo.splice(idx, 1)[0];
        this.columnasGrupo.push(item);
      }
    },
    // Métodos para mover elementos en la lista unificada (columnas + agrupaciones)
    moverColumnaEnLista(item, direction) {
      // Encontrar el índice real en columnasGrupo
      const idx = this.columnasGrupo.findIndex(
        (c) =>
          c.idexterno === item.idexterno &&
          c.encuestaCodigo === item.encuestaCodigo
      );
      if (idx === -1) return;

      // Calcular nuevo índice considerando agrupaciones
      const listaActual = this.columnasParaMostrar;
      const idxEnLista = listaActual.findIndex(
        (el) =>
          !el.esAgrupacion &&
          el.idexterno === item.idexterno &&
          el.encuestaCodigo === item.encuestaCodigo
      );

      const nuevoIdxEnLista = idxEnLista + direction;
      if (nuevoIdxEnLista < 0 || nuevoIdxEnLista >= listaActual.length) return;

      const elementoDestino = listaActual[nuevoIdxEnLista];

      if (elementoDestino.esAgrupacion) {
        // Mover antes o después de la agrupación
        const primeraColumnaAgrup = elementoDestino.columnas[0];
        const idxAgrup = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === primeraColumnaAgrup.idexterno &&
            c.encuestaCodigo === primeraColumnaAgrup.encuestaCodigo
        );
        const columna = this.columnasGrupo.splice(idx, 1)[0];
        const nuevoIdx =
          direction < 0 ? idxAgrup : idxAgrup + elementoDestino.columnas.length;
        this.columnasGrupo.splice(
          nuevoIdx > idx ? nuevoIdx - 1 : nuevoIdx,
          0,
          columna
        );
      } else {
        // Mover con otra columna individual
        const idxDestino = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === elementoDestino.idexterno &&
            c.encuestaCodigo === elementoDestino.encuestaCodigo
        );
        const temp = this.columnasGrupo[idx];
        this.$set(this.columnasGrupo, idx, this.columnasGrupo[idxDestino]);
        this.$set(this.columnasGrupo, idxDestino, temp);
      }
    },
    moverColumnaAlInicioEnLista(item) {
      const idx = this.columnasGrupo.findIndex(
        (c) =>
          c.idexterno === item.idexterno &&
          c.encuestaCodigo === item.encuestaCodigo
      );
      if (idx > 0) {
        const columna = this.columnasGrupo.splice(idx, 1)[0];
        this.columnasGrupo.unshift(columna);
      }
    },
    moverColumnaAlFinalEnLista(item) {
      const idx = this.columnasGrupo.findIndex(
        (c) =>
          c.idexterno === item.idexterno &&
          c.encuestaCodigo === item.encuestaCodigo
      );
      if (idx < this.columnasGrupo.length - 1) {
        const columna = this.columnasGrupo.splice(idx, 1)[0];
        this.columnasGrupo.push(columna);
      }
    },
    moverAgrupacion(agrupItem, direction) {
      const agrupacion = this.agrupacionesColumnas.find(
        (a) => a.id === agrupItem.agrupacionId
      );
      if (!agrupacion) return;

      // Encontrar los índices de las columnas de la agrupación
      const indicesAgrupacion = [];
      agrupacion.columnas.forEach((colAgrup) => {
        const idx = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === colAgrup.idexterno &&
            c.encuestaCodigo === colAgrup.encuestaCodigo
        );
        if (idx !== -1) indicesAgrupacion.push(idx);
      });

      if (indicesAgrupacion.length === 0) return;

      indicesAgrupacion.sort((a, b) => a - b);
      const primerIdx = indicesAgrupacion[0];
      const ultimoIdx = indicesAgrupacion[indicesAgrupacion.length - 1];

      // Obtener la lista actual para saber qué elemento está arriba/abajo
      const listaActual = this.columnasParaMostrar;
      const idxEnLista = listaActual.findIndex(
        (el) => el.esAgrupacion && el.agrupacionId === agrupItem.agrupacionId
      );

      const nuevoIdxEnLista = idxEnLista + direction;
      if (nuevoIdxEnLista < 0 || nuevoIdxEnLista >= listaActual.length) return;

      const elementoDestino = listaActual[nuevoIdxEnLista];

      // Extraer todas las columnas de la agrupación
      const columnasAgrupadas = indicesAgrupacion
        .sort((a, b) => b - a)
        .map((idx) => this.columnasGrupo.splice(idx, 1)[0]);
      columnasAgrupadas.reverse();

      let nuevoIdx;
      if (elementoDestino.esAgrupacion) {
        // Mover antes o después de otra agrupación
        const primeraColumnaDestino = elementoDestino.columnas[0];
        const idxDestino = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === primeraColumnaDestino.idexterno &&
            c.encuestaCodigo === primeraColumnaDestino.encuestaCodigo
        );
        nuevoIdx =
          direction < 0
            ? idxDestino
            : idxDestino + elementoDestino.columnas.length;
      } else {
        // Mover antes o después de una columna individual
        const idxDestino = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === elementoDestino.idexterno &&
            c.encuestaCodigo === elementoDestino.encuestaCodigo
        );
        nuevoIdx = direction < 0 ? idxDestino : idxDestino + 1;
      }

      // Insertar las columnas agrupadas en la nueva posición
      columnasAgrupadas.forEach((col, i) => {
        this.columnasGrupo.splice(nuevoIdx + i, 0, col);
      });
    },
    moverAgrupacionAlInicio(agrupItem) {
      const agrupacion = this.agrupacionesColumnas.find(
        (a) => a.id === agrupItem.agrupacionId
      );
      if (!agrupacion) return;

      // Extraer columnas de la agrupación
      const columnasAgrupadas = [];
      agrupacion.columnas.forEach((colAgrup) => {
        const idx = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === colAgrup.idexterno &&
            c.encuestaCodigo === colAgrup.encuestaCodigo
        );
        if (idx !== -1) {
          columnasAgrupadas.push({ col: this.columnasGrupo[idx], idx });
        }
      });

      // Ordenar por índice descendente para extraer sin afectar índices
      columnasAgrupadas.sort((a, b) => b.idx - a.idx);
      columnasAgrupadas.forEach((item) => {
        this.columnasGrupo.splice(item.idx, 1);
      });

      // Insertar al inicio
      columnasAgrupadas.reverse().forEach((item, i) => {
        this.columnasGrupo.splice(i, 0, item.col);
      });
    },
    moverAgrupacionAlFinal(agrupItem) {
      const agrupacion = this.agrupacionesColumnas.find(
        (a) => a.id === agrupItem.agrupacionId
      );
      if (!agrupacion) return;

      // Extraer columnas de la agrupación
      const columnasAgrupadas = [];
      agrupacion.columnas.forEach((colAgrup) => {
        const idx = this.columnasGrupo.findIndex(
          (c) =>
            c.idexterno === colAgrup.idexterno &&
            c.encuestaCodigo === colAgrup.encuestaCodigo
        );
        if (idx !== -1) {
          columnasAgrupadas.push({ col: this.columnasGrupo[idx], idx });
        }
      });

      // Ordenar por índice descendente para extraer sin afectar índices
      columnasAgrupadas.sort((a, b) => b.idx - a.idx);
      columnasAgrupadas.forEach((item) => {
        this.columnasGrupo.splice(item.idx, 1);
      });

      // Insertar al final
      columnasAgrupadas.reverse().forEach((item) => {
        this.columnasGrupo.push(item.col);
      });
    },
    resetearOrdenColumnas() {
      this.columnasGrupo = JSON.parse(
        JSON.stringify(this.columnasGrupoOriginal)
      );
      // Limpiar agrupaciones al resetear
      this.agrupacionesColumnas = [];
      this.columnasSeleccionadas = [];
      this.busquedaColumnaDebounced = "";
      if (this.$refs.inputBusquedaColumna) {
        this.$refs.inputBusquedaColumna.value = "";
      }
    },
    guardarColumnasGrupo(cerrarAlTerminar = false) {
      if (!this.grupoColumnas) return;
      this.loadingColumnas = true;
      const columnas = this.columnasGrupo.map((col, idx) => ({
        idexterno: col.idexterno,
        nombre: col.nombre,
        encuestaCodigo: col.encuestaCodigo,
        encuestaNombre: col.encuestaNombre,
        orden: idx,
        agrupacionId: col.agrupacionId || null,
      }));
      services
        .ws("post", "guardarColumnasGrupo", {
          codigo: this.grupoColumnas.codigo,
          columnas: columnas,
          agrupaciones: this.agrupacionesColumnas,
        })
        .then((res) => {
          if (res.ok) {
            this.columnasGrupoOriginal = JSON.parse(
              JSON.stringify(this.columnasGrupo)
            );
            this.success = true;
            this.msgSuccess = res.message;
            if (cerrarAlTerminar) {
              this.dialogColumnasGrupo = false;
            }
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loadingColumnas = false;
        });
    },
    guardarYCerrarColumnasGrupo() {
      this.guardarColumnasGrupo(true);
    },
    cerrarColumnasGrupo() {
      this.busquedaColumnaDebounced = "";
      if (this.$refs.inputBusquedaColumna) {
        this.$refs.inputBusquedaColumna.value = "";
      }
      this.columnasSeleccionadas = [];
      this.dialogColumnasGrupo = false;
    },
    // Métodos para agrupación de columnas
    getClaveColumna(col) {
      return `${col.idexterno}||${col.nombre}||${col.encuestaCodigo}`;
    },
    getEncuestasAgrupadasTexto(encuestasAgrupadas) {
      if (!encuestasAgrupadas || encuestasAgrupadas.length === 0) {
        return "";
      }
      // Extraer solo los nombres y unir con pipes
      const nombres = encuestasAgrupadas.map((e) => e.nombre);
      const textoCompleto = nombres.join(" | ");
      // Si es muy largo, truncar y mostrar cuántas hay
      if (textoCompleto.length > 50) {
        return `${nombres[0]} | +${nombres.length - 1} más`;
      }
      return textoCompleto;
    },
    isColumnaSeleccionada(col) {
      return this.columnasSeleccionadas.includes(this.getClaveColumna(col));
    },
    seleccionarTodas() {
      // Solo seleccionar columnas individuales (no agrupaciones)
      const clavesFiltradas = this.columnasGrupoFiltradas
        .filter((item) => !item.esAgrupacion)
        .map((col) => this.getClaveColumna(col));
      // Toggle: si todas están seleccionadas, deseleccionar; si no, seleccionar todas
      const todasSeleccionadas = clavesFiltradas.every((clave) =>
        this.columnasSeleccionadas.includes(clave)
      );
      if (todasSeleccionadas) {
        this.columnasSeleccionadas = this.columnasSeleccionadas.filter(
          (clave) => !clavesFiltradas.includes(clave)
        );
      } else {
        const nuevasSelecciones = clavesFiltradas.filter(
          (clave) => !this.columnasSeleccionadas.includes(clave)
        );
        this.columnasSeleccionadas = [
          ...this.columnasSeleccionadas,
          ...nuevasSelecciones,
        ];
      }
    },
    agruparColumnasSeleccionadas() {
      if (this.columnasSeleccionadas.length < 2) {
        this.error = true;
        this.msgError = "Selecciona al menos 2 columnas para agrupar";
        return;
      }
      // Obtener las columnas seleccionadas
      const columnasParaAgrupar = this.columnasGrupo.filter((col) =>
        this.columnasSeleccionadas.includes(this.getClaveColumna(col))
      );
      // Crear ID único para la agrupación
      const agrupacionId = "agrup_" + Date.now();
      // Crear la agrupación
      const nuevaAgrupacion = {
        id: agrupacionId,
        nombreUnificado: columnasParaAgrupar[0].nombre,
        columnas: columnasParaAgrupar.map((col) => ({
          idexterno: col.idexterno,
          nombre: col.nombre,
          encuestaCodigo: col.encuestaCodigo,
          encuestaNombre: col.encuestaNombre,
        })),
      };
      this.agrupacionesColumnas.push(nuevaAgrupacion);
      // Marcar las columnas como agrupadas
      columnasParaAgrupar.forEach((col) => {
        col.agrupacionId = agrupacionId;
      });
      // Limpiar selección
      this.columnasSeleccionadas = [];
      this.success = true;
      this.msgSuccess = "Columnas agrupadas correctamente";
    },
    eliminarAgrupacion(idx) {
      const agrupacion = this.agrupacionesColumnas[idx];
      // Desmarcar las columnas de la agrupación
      this.columnasGrupo.forEach((col) => {
        if (col.agrupacionId === agrupacion.id) {
          col.agrupacionId = null;
        }
      });
      this.agrupacionesColumnas.splice(idx, 1);
    },
    quitarDeAgrupacion(agrupIdx, colIdx) {
      const agrupacion = this.agrupacionesColumnas[agrupIdx];
      if (!agrupacion) return;

      const colInfo = agrupacion.columnas[colIdx];
      if (!colInfo) return;

      // Desmarcar la columna
      const columna = this.columnasGrupo.find(
        (col) =>
          col.idexterno === colInfo.idexterno &&
          col.encuestaCodigo === colInfo.encuestaCodigo
      );
      if (columna) {
        columna.agrupacionId = null;
      }

      // Si después de quitar quedaría solo 1 columna, eliminar toda la agrupación
      if (agrupacion.columnas.length <= 2) {
        // Desmarcar todas las columnas de la agrupación
        this.columnasGrupo.forEach((col) => {
          if (col.agrupacionId === agrupacion.id) {
            col.agrupacionId = null;
          }
        });
        // Eliminar la agrupación
        this.agrupacionesColumnas.splice(agrupIdx, 1);
        this.success = true;
        this.msgSuccess =
          "Agrupación eliminada porque quedaron menos de 2 columnas";
      } else {
        // Solo quitar de la agrupación
        agrupacion.columnas.splice(colIdx, 1);
      }
    },
  },
  computed: {
    encuestasDisponibles() {
      return this.items.filter((item) => {
        // No mostrar si ya está en el grupo actual
        if (this.formGrupo.encuestas.find((e) => e.codigo === item.id)) {
          return false;
        }
        // No mostrar si ya está en otro grupo (excepto el grupo actual que se está editando)
        const enOtroGrupo = this.grupos.find(
          (g) =>
            g.codigo !== this.formGrupo.codigo &&
            g.encuestas &&
            g.encuestas.some((e) => e.codigo === item.id)
        );
        return !enOtroGrupo;
      });
    },
    // Encuestas que están en otros grupos (para mostrar información)
    encuestasEnOtrosGrupos() {
      const mapa = {};
      this.grupos.forEach((grupo) => {
        if (grupo.codigo !== this.formGrupo.codigo && grupo.encuestas) {
          grupo.encuestas.forEach((enc) => {
            mapa[enc.codigo] = grupo.nombre;
          });
        }
      });
      return mapa;
    },
    // Set de claves de columnas agrupadas (optimización)
    columnasAgrupadasSet() {
      const set = new Set();
      this.agrupacionesColumnas.forEach((agrup) => {
        agrup.columnas.forEach((col) => {
          set.add(`${col.idexterno}||${col.nombre}||${col.encuestaCodigo}`);
        });
      });
      return set;
    },
    // Lista unificada: columnas individuales + agrupaciones como un solo elemento
    columnasParaMostrar() {
      const columnasAgrupadas = this.columnasAgrupadasSet;

      // Crear mapa de agrupaciones por posición mínima
      const agrupacionesPorPosicion = new Map();
      this.agrupacionesColumnas.forEach((agrup) => {
        let posicionMinima = Infinity;
        for (const colAgrup of agrup.columnas) {
          const idx = this.columnasGrupo.findIndex(
            (c) =>
              c.idexterno === colAgrup.idexterno &&
              c.encuestaCodigo === colAgrup.encuestaCodigo
          );
          if (idx !== -1 && idx < posicionMinima) {
            posicionMinima = idx;
            break; // Optimización: tomar la primera encontrada
          }
        }
        if (posicionMinima !== Infinity) {
          agrupacionesPorPosicion.set(posicionMinima, {
            esAgrupacion: true,
            agrupacionId: agrup.id,
            nombreUnificado: agrup.nombreUnificado,
            columnas: agrup.columnas,
          });
        }
      });

      // Construir resultado en una sola pasada
      const resultado = [];
      const agrupacionesUsadas = new Set();

      for (let idx = 0; idx < this.columnasGrupo.length; idx++) {
        // Agregar agrupación si corresponde a esta posición
        if (agrupacionesPorPosicion.has(idx) && !agrupacionesUsadas.has(idx)) {
          resultado.push(agrupacionesPorPosicion.get(idx));
          agrupacionesUsadas.add(idx);
        }

        // Agregar columna si no está agrupada
        const col = this.columnasGrupo[idx];
        const clave = `${col.idexterno}||${col.nombre}||${col.encuestaCodigo}`;
        if (!columnasAgrupadas.has(clave)) {
          resultado.push({
            esAgrupacion: false,
            idexterno: col.idexterno,
            nombre: col.nombre,
            encuestaCodigo: col.encuestaCodigo,
            encuestaNombre: col.encuestaNombre,
            encuestasAgrupadas: col.encuestasAgrupadas,
          });
        }
      }

      return resultado;
    },
    columnasGrupoFiltradas() {
      const lista = this.columnasParaMostrar;
      const busqueda = this.busquedaColumnaDebounced;

      if (!busqueda) {
        return lista;
      }

      const busquedaLower = busqueda.toLowerCase();
      return lista.filter((item) => {
        if (item.esAgrupacion) {
          if (item.nombreUnificado.toLowerCase().includes(busquedaLower)) {
            return true;
          }
          return item.columnas.some(
            (col) =>
              col.nombre.toLowerCase().includes(busquedaLower) ||
              col.idexterno.toLowerCase().includes(busquedaLower)
          );
        }
        return (
          item.nombre.toLowerCase().includes(busquedaLower) ||
          item.idexterno.toLowerCase().includes(busquedaLower)
        );
      });
    },
  },
};
</script>

<style scoped>
.busqueda-columna-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}
.busqueda-columna-input:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 1px #1976d2;
}
</style>
